var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('b-row',{staticClass:"mb-5"},[_c('b-col',[_c('Chart',{attrs:{"title":'Cantidad de trabajos por estado [filtrado]',"orders":_vm.chart}})],1)],1),_c('b-row',[_c('b-col',[_c('ChartSector',{attrs:{"title":'Cantidad OT por sector [filtrado]',"orders":_vm.chart2}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }